/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * 包含待分析文本 'text' 的JSON对象
 */
export type PostTextAnalyzeRequest = { text: string };

export const PostTextAnalyzeRequest$zodSchema: z.ZodType<
  PostTextAnalyzeRequest
> = z.object({
  text: z.string(),
}).describe("包含待分析文本 'text' 的JSON对象");

export type PostTextAnalyzeDetails = {};

export const PostTextAnalyzeDetails$zodSchema: z.ZodType<
  PostTextAnalyzeDetails
> = z.object({});

/**
 * 请求体无效或文本为空
 */
export type PostTextAnalyzeBadRequestResponseBody = {
  code?: string | undefined;
  details?: PostTextAnalyzeDetails | undefined;
  message?: string | undefined;
};

export const PostTextAnalyzeBadRequestResponseBody$zodSchema: z.ZodType<
  PostTextAnalyzeBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => PostTextAnalyzeDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe("请求体无效或文本为空");

/**
 * 成功响应
 */
export type PostTextAnalyzeResponseBody = {
  characters?: number | undefined;
  lines?: number | undefined;
  paragraphs?: number | undefined;
  sentences?: number | undefined;
  words?: number | undefined;
};

export const PostTextAnalyzeResponseBody$zodSchema: z.ZodType<
  PostTextAnalyzeResponseBody
> = z.object({
  characters: z.int().optional(),
  lines: z.int().optional(),
  paragraphs: z.int().optional(),
  sentences: z.int().optional(),
  words: z.int().optional(),
}).describe("成功响应");

export type PostTextAnalyzeResponse =
  | PostTextAnalyzeResponseBody
  | PostTextAnalyzeBadRequestResponseBody;

export const PostTextAnalyzeResponse$zodSchema: z.ZodType<
  PostTextAnalyzeResponse
> = z.union([
  z.lazy(() => PostTextAnalyzeResponseBody$zodSchema),
  z.lazy(() => PostTextAnalyzeBadRequestResponseBody$zodSchema),
]);
